import React from 'react';

const PrivacyPolicy = () => {
  const styles = {
    header: { background: '#f7f7f7', padding: '60px 24px', textAlign: 'center' },
    title: { fontSize: '2.5rem', fontWeight: '700', marginBottom: '16px' },
    container: { maxWidth: '800px', margin: '0 auto', padding: '60px 24px' },
    section: { marginBottom: '32px' },
    sectionTitle: { fontSize: '1.25rem', fontWeight: '600', marginBottom: '16px' },
    text: { color: '#444', lineHeight: '1.8', marginBottom: '16px' }
  };

  return (
    <>
      <header style={styles.header}>
        <h1 style={styles.title}>Privacy Policy</h1>
        <p style={{ color: '#555' }}>Last updated: January 2025</p>
      </header>

      <section style={styles.container}>
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>1. Information We Collect</h2>
          <p style={styles.text}>
            We collect information you provide directly, including name, email address, phone number, payment information, and booking details when you make a reservation or create an account.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>2. How We Use Your Information</h2>
          <p style={styles.text}>
            We use your information to process bookings, communicate with you about your stay, improve our services, send marketing communications (with your consent), and comply with legal obligations.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>3. Information Sharing</h2>
          <p style={styles.text}>
            We do not sell your personal information. We may share information with service providers who assist in our operations, payment processors, and as required by law.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>4. Data Security</h2>
          <p style={styles.text}>
            We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is 100% secure.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>5. Cookies</h2>
          <p style={styles.text}>
            We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. You can control cookie settings through your browser.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>6. Your Rights</h2>
          <p style={styles.text}>
            You have the right to access, correct, or delete your personal information. You may also object to certain processing or request data portability. Contact us to exercise these rights.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>7. Contact Us</h2>
          <p style={styles.text}>
            For privacy-related inquiries, please contact us at privacy@kasbiastays.co.uk
          </p>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
